import type { Dayjs } from 'dayjs';

export enum EndType {
  NEVER = 'never',
  AFTER = 'after',
  ON = 'on',
}

export interface EndDetails<TDate extends Dayjs> {
  endDate: TDate | null;
  endingType: EndType;
  occurrences: number | null;
}
